// Date only, for report labels that never showed a time. Reports created before the
// start was server-stamped hold an RFC-1123 string and newer ones ISO; new Date() reads
// both, and anything it can't becomes empty rather than the literal "Invalid Date".
export const formatReportDate = (date) => {
    if (!date) return '';

    const dateObj = new Date(date);

    if (isNaN(dateObj)) return '';

    return dateObj.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
};

export const formatDateTimeForZipMenue = (date) => {
    if (!date) return '';

    const utcDate = date.endsWith('Z') ? date : `${date}Z`;

    const dateObj = new Date(utcDate);

    if (isNaN(dateObj)) return '';

    const formattedDate = dateObj.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });

    const formattedTime = dateObj.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    return `${formattedDate} at ${formattedTime}`;
};
